function initHelp(root) {
  if (root.dataset.helpReady) return;
  root.dataset.helpReady = 'true';
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  function activate(tab) {
    tabs.forEach(t => {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      root.querySelector('#' + t.dataset.tab).hidden = !selected;
    });
  }
  if (tabs.length) activate(tabs[0]);
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', e => {
      let next;
      if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      else return;
      e.preventDefault(); activate(tabs[next]); tabs[next].focus();
    });
  });
  function openPolicy() {
    if (location.hash === '#conditions-completes') {
      const policy = root.querySelector('#conditions-completes');
      if (policy) { policy.open = true; policy.scrollIntoView({block:'start'}); }
    }
  }
  root.querySelectorAll('a[href="#conditions-completes"]').forEach(a => a.addEventListener('click', () => {root.querySelector('#conditions-completes').open = true;}));
  openPolicy();
  const result = root.querySelector('[data-help-result]');
  if (result) { result.focus(); result.scrollIntoView({block:'center'}); }
}
document.querySelectorAll('.lsf-help').forEach(initHelp);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.lsf-help').forEach(initHelp));
